import React from 'react';
import { createPortal } from 'react-dom';
import { X, LogOut } from 'lucide-react';
import './ForcedLogoutModal.css';

const ForcedLogoutModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onClose();
    window.location.href = '/login';
  };

  return createPortal(
    <div className="forced-logout-overlay" onClick={handleConfirm}>
      <div
        className="forced-logout-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          className="forced-logout-close"
          onClick={handleConfirm}
          aria-label="Close"
          type="button"
        >
          <X size={20} />
        </button>

        <div className="forced-logout-content">
          <div className="forced-logout-icon-wrapper">
            <LogOut size={36} className="forced-logout-icon" />
          </div>
          <h2 className="forced-logout-title">You’ve been signed out</h2>
          <p className="forced-logout-message">
            Your account was signed in on another browser or device, so this
            session has been securely logged out.
          </p>
          <button
            className="forced-logout-button"
            type="button"
            onClick={handleConfirm}
          >
            Go to Login
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ForcedLogoutModal;


